<template>
  <b-table
    class="analytics-table"
    :data="analytics"
    :checkable="select"
    :checked-rows.sync="internalSelected"
    :custom-is-checked="isChecked"
    default-sort-direction="asc"
    default-sort="name">
    <template slot-scope="props">
      <b-table-column label="Type" class="type-icon" field="inputType" sortable centered>
        <analytic-event-type-icon :analytic="props.row"></analytic-event-type-icon>
      </b-table-column>
      <b-table-column v-if="admin" label="Released" centered>
        <svgicon v-if="props.row.released" name="circle" height="15" width="15">
        </svgicon>
      </b-table-column>
      <b-table-column
        v-if="!admin" label="Owner" class="type-icon" centered field="digita" sortable>
        <svgicon v-if="props.row.digita" name="shield" height="15" width="15">
        </svgicon>
        <svgicon v-else name="org" height="20" width="20"></svgicon>
      </b-table-column>
      <b-table-column label="Modified" class="date" field="updated" sortable>
        {{ props.row.updated | formatEpochDate(gmt) }}
      </b-table-column>
      <b-table-column label="Name" field="name" sortable>
        <router-link :to="{ name: link, params: { id: props.row.uuid }}">
          {{ props.row.name }}
        </router-link>
      </b-table-column>
      <b-table-column label="Categories">
        <div class="tags">
          <span
            v-for="cat in props.row.categories"
            :key="cat"
            @click="$emit('analytic-table-cat-click', { cat })"
            class="tag clickable is-small">
            {{ cat }}
          </span>
        </div>
      </b-table-column>
      <b-table-column label="Actions">
        <div class="tags">
          <span
            v-for="action in props.row.actions"
            :key="action"
            @click="$emit('analytic-table-action-click', { action })"
            class="tag clickable is-small">
            {{ action }}
          </span>
        </div>
      </b-table-column>
      <b-table-column label="Tags">
        <div class="tags">
          <span
            v-for="tag in props.row.tags"
            :key="tag"
            @click="$emit('analytic-table-tag-click', { tag })"
            class="tag clickable is-small">
            {{ tag }}
          </span>
        </div>
      </b-table-column>
    </template>
    </b-table>
</template>

<script>
import gmt from '@/mixins/gmt';
import AnalyticEventTypeIcon from '@/components/analytics/AnalyticEventTypeIcon.vue';

export default {
  name: 'AnalyticsTable',
  mixins: [gmt],
  components: { AnalyticEventTypeIcon },
  props: {
    analytics: {
      type: Array,
      required: true,
    },
    select: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
    },
    admin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalSelected: this.selected,
      selectAll: false,
    };
  },
  watch: {
    internalSelected() {
      this.$emit('update:selected', this.internalSelected);
    },
  },
  computed: {
    link() {
      if (this.admin) {
        return 'admin.analytics.index.detail';
      }
      return 'analytics.index.detail';
    },
  },
  methods: {
    isChecked(a, b) {
      if (a.uuid === b.uuid) {
        return true;
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.analytics-table {
  th.type-icon, td.type-icon {
    width: $table-icon-size;
    text-align: center;
    span {
      img {
        width: $table-icon-size;
        height: $table-icon-size;
        margin-bottom: -6px;
      }
    }
  }

  th.date, td.date {
    width: $table-date-width;
  }
}

</style>
